<script setup>
const props = defineProps({
	title: {
		type: String,
		required: false,
	},
	smallTitle: {
		type: String,
		required: false,
	},
	expanded: {
		type: Boolean,
		required: false,
	},
	icon: {
		type: String,
		required: false,
	},
})
</script>

<template>
	<div :class="['flex min-w-0 max-w-full flex-col gap-8 border-[.5px] border-snk-light-800 not-last-of-type:border-b', expanded ? 'px-5 py-8' : 'p-5']">
		<div class="flex gap-2" v-if="title || smallTitle">
			<i :class="`text-snk-blue-500 ${icon}`" v-if="icon"></i>
			<div class="h6" v-if="title">{{ title }}</div>
			<div class="-pt-[.5rem] text-sm font-semibold uppercase" v-if="smallTitle">{{ smallTitle }}</div>
		</div>

		<div class="flex h-full min-w-0 max-w-full flex-col justify-end gap-5">
			<slot />
		</div>
	</div>
</template>
